// @ts-ignore
import * as hasOwn from 'object.hasown';

if (!Object.hasOwn) {
	hasOwn.shim();
}
